import React                           from "react";
import { useRouter }                   from "next/router";
import { isInsideThirdPartyApp }       from "_root/thirdParty";
import { openInBrowser }               from "_root/thirdParty/paytm-mini-app";
import { DOWNLOAD_LINK_HEADER }        from "_config/index";
import { isPageRoute }                 from "_common/utils";
import { storeEvent, openAppSingular } from "_root/analytics";
import { SNG_STICKY_LINK }             from "_config/index";
import Presentation                    from "./presentation";

const component = props => {
	const router              = useRouter ();
	const handleDownloadClick = () => {
		const thirdPartyApp = isInsideThirdPartyApp ();

		let label;

		if ( isPageRoute ( { page: "home", router } ) )
			label = "Open_in_app_home";

		if ( isPageRoute ( { page: "stream", router } ) )
			label = "Open_in_app_broadcast";

		storeEvent ( "Download", label );

		if ( thirdPartyApp ) {
			openInBrowser ( { url: DOWNLOAD_LINK_HEADER } );
		} else {
			openAppSingular ( SNG_STICKY_LINK, "Header" );
		}
	};

	return (
		<Presentation
			{ ...props }
			handleDownloadClick = { handleDownloadClick }
		/>
	);
};

export default component;
